import script from "./QuickAddItem.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickAddItem.vue?vue&type=script&setup=true&lang=js"

import "./QuickAddItem.vue?vue&type=style&index=0&id=327b4351&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-327b4351"]])

export default __exports__